"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function handleClick(elem, name, onChange) {
    if (elem.offerCount > 0 || elem.active) {
        onChange(elem, name);
    }
}
const FilterDropdownView = ({ id, isDisabled, onChange, title, name, values, isMultiselect, }, isOpen, ref) => {
    const selectedItems = values
        .filter((elem) => elem.active)
        .map((elem) => elem.label).join(', ');
    return react_1.default.createElement("div", { id: id, ref: ref, className: `dropdown-container${isOpen ? ' open' : ''}${isDisabled === true ? ' disabled' : ''}`, title: `${title}: ${selectedItems}` },
        react_1.default.createElement("div", { className: "dropdown-current-item" },
            react_1.default.createElement("span", null,
                title,
                ":\u00A0"),
            react_1.default.createElement("span", null, selectedItems)),
        react_1.default.createElement("ul", { className: "dropdown-list" }, values.map((elem) => react_1.default.createElement("li", { className: `${elem.active === true ? 'selected' : ''}
                        dropdown-item ${elem.offerCount === 0 && elem.active === false ? 'disabled' : ''}`, "data-value": elem.value, key: elem.label.toString(), onClick: () => handleClick(elem, name, onChange) },
            isMultiselect === false
                && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "radiobox" }),
                    name === 'mileage'
                        && react_1.default.createElement(react_1.default.Fragment, null, "od\u00A0"),
                    elem.label,
                    react_1.default.createElement("span", { className: "counter", translate: "no" },
                        "(",
                        elem.offerCount,
                        ")"),
                    elem.active === true && react_1.default.createElement("span", { className: "reset-filter-item", title: "Odebrat polo\u017Eku" })),
            isMultiselect === true
                && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "checkbox" }),
                    elem.label,
                    "\u00A0",
                    react_1.default.createElement("span", { className: "counter", translate: "no" },
                        "(",
                        elem.offerCount,
                        ")"))))));
};
exports.default = FilterDropdownView;
